import { Box, Typography, Card, CardContent, Alert, AlertTitle } from '@mui/material';
import { Settings as SettingsIcon } from '@mui/icons-material';

export function SettingsPage() {
    return (
        <Box>
            <Box sx={{ mb: 4 }}>
                <Typography variant="h1" gutterBottom>
                    Settings
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Configure application preferences and system settings
                </Typography>
            </Box>

            <Card>
                <CardContent sx={{ p: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <SettingsIcon sx={{ mr: 2, color: 'secondary.main' }} />
                        <Typography variant="h5">System Settings</Typography>
                    </Box>

                    <Alert severity="info" sx={{ mt: 2 }}>
                        <AlertTitle>Coming Soon</AlertTitle>
                        Advanced settings and configuration options are being developed. This will include system preferences, user management, security
                        settings, and integration configurations.
                    </Alert>
                </CardContent>
            </Card>
        </Box>
    );
}
